<template>
  <section class="video-carousel">
    <div class="track" ref="track">
      <div ref="items" class="item" :key="video.io" v-for="video in item.videos">
        <h2>{{ video.cta }}</h2>
        <media :item="video" />
      </div>
    </div>

    <div class="wrap" v-if="['Home'].indexOf($route.name) > -1">
      <router-link :to="{ name: 'Cases'}" class="button-link all-cases">
        Se alle cases
        <span><icon-slide-arrow fill="#E4003F" /></span>
      </router-link>
    </div>

    <div v-if="showPrev && current > 0" class="next" @click="next">
      <span><icon-slide-arrow fill="#E4003F" /></span>
    </div>
    <div v-if="showPrev && current < count - 1" class="prev" @click="prev">
      <span><icon-slide-arrow fill="#E4003F" /></span>
    </div>
  </section>
</template>

<script>
import AbstractSection from './abstract'
import Media from './media'
import TweenLite from 'gsap'
import iconSlideArrow from '@icons/icon-slide-arrow'

export default AbstractSection.extend({
  components: { Media, iconSlideArrow },
  data: () => ({
    current: 0,
    showPrev: true,
    elmWidth: 0
  }),
  computed: {
    count () {
      return this.item.videos.length
    }
  },
  async mounted () {
    await this.$nextTick()

    this.showPrev = this.count > 1 && !this.isVisible(this.$refs.items[this.$refs.items.length - 1])
    this.elmWidth = this.$refs.items[1].offsetWidth

    if (this.count > 1) {
      window.addEventListener('resize', () => {
        TweenLite.set(this.$refs.track, { x: 0 })

        this.showPrev = this.count > 1 && !this.isVisible(this.$refs.items[this.$refs.items.length - 1])

        this.elmWidth = this.$refs.items[1].offsetWidth

        if (this.showPrev) {
          TweenLite.set(this.$refs.track, { x: this.current * -this.elmWidth })
        }
      })
    }
  },
  methods: {
    next () {
      if (this.current - 1 < 0) {
        return
      }

      this.current--

      TweenLite.to(this.$refs.track, 0.255, { x: `+=${this.elmWidth}px` })
    },

    prev () {
      if (this.current + 1 >= this.count) {
        return
      }

      this.current++

      TweenLite.to(this.$refs.track, 0.255, { x: `-=${this.elmWidth}px` })
    },

    isVisible (el) {
      let bounds = el.getBoundingClientRect()
      return window.innerWidth > bounds.left && window.innerWidth > bounds.right
    }
  }
})
</script>

<style lang="scss" scoped>
  @import '~@styles/global/index';
  @import '~@styles/colors/variables';
  @import '~@styles/mixins/font-size';
  @import '~@animations/easings/variables';
  @import '~@animations/durations/variables';
  @import '~@styles/mq/variables';

  .video-carousel {
    position: relative;
    margin-bottom: $global-padding * 10;
  }

  .track {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: no-wrap;
    padding-left: 15vw;

    @media #{$below-breakpoint-768} {
      padding-left: 2.5vw;
    }
  }

  .next, .prev {
    width: $global-padding * 4;
    height: calc(100% - 50px);
    background-color: rgba($color-white, 0.9);
    cursor: pointer;
    position: absolute;
    bottom: 0;
    z-index: 10;
    transition: background-color $duration-normal $easeing-OutExpo;

    &:hover {
      background-color: rgba($color-white, 0.85);
    }

    @media #{$below-breakpoint-768} {
      height: 60px;
      width: 60px;

      bottom: 50%;

      transform: translateY(100%);

      border-radius: 50%;
    }

    span {
      position: absolute;
      top: 50%;

      transform: translateY(-15px);
    }
  }

  .next {
    left: 0;

    @media #{$below-breakpoint-768} {
      left: 15px;
    }

    span {
      right: 50%;

      @media #{$below-breakpoint-768} {
        transform: translateX(7px) translateY(-15px) scale(0.95);
      }
    }

    svg {
      transform: rotate(90deg) scale(0.75);
    }
  }

  .prev {
    right: 0;

    @media #{$below-breakpoint-768} {
      right: 15px;
    }

    span {
      left: 50%;

      @media #{$below-breakpoint-768} {
        transform: translateX(-7px) translateY(-15px) scale(0.95);
      }
    }

    svg {
      transform: rotate(-90deg) scale(0.75);
    }
  }

  .item + .item {
    padding-left: 50px;
  }

  h2 {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: $global-padding;
  }

  .wrap {
    position: relative;
    text-align: center;
  }

  .all-cases {
    position: absolute;
    right: 50%;
    bottom: -60px;

    transform: translate(50%);

    @include font-size(18px, 22px);
    font-weight: bold;
    color: $color-red;
    text-align: right;

    display: flex;
    align-items: center;

     @media #{$above-breakpoint-768} {
      right: $global-padding * 2;
      transform: translate(0);
    }

    &:hover {
      color: $color-red-x;

      span {
        transition: transform $duration-normal $easeing-OutExpo;
        transform: translateX(5px);
      }

      svg {
        fill: $color-red-x;
      }
    }

    span {
      transition: transform $duration-normal $easeing-OutExpo;
      margin-left: $global-padding;

      svg {
        transform: rotate(-90deg) scale(0.85);

      }
    }
  }
</style>

<style lang="scss">
  .video-carousel .media {
    width: 95vw;
    max-width: 500px;

    &, .wrap {
      padding: 0;
      margin: 0;
    }

    .media-text {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/video-slider.vue